import type { LocationQueryValue } from "vue-router";

/**
 * The `?learning_path_id=` query as one parcours id, or null when it designates none.
 *
 * Vue Router hands a repeated key back as an array (`?learning_path_id=a&learning_path_id=b`) and an
 * empty value as `""`; neither is an id, and passing them through to the API only produces a 400 and
 * an empty modal. Shared by the route guard and the deep-link composable so both read the URL alike.
 */
export function learningPathIdFromQuery(value: LocationQueryValue | LocationQueryValue[] | undefined): string | null {
  return typeof value === "string" && value.length > 0 ? value : null;
}
